import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService } from '../../../../core';

import * as _ from 'lodash';
import { PessoaContato } from '../pessoa-contato';
import { contatoSituacoes } from '../situacao';
import { PessoaContatoTipo, PessoaContatoTipoSortPipe, outrosContatosTipos, isContatoTipoPrimario, isContatoTipoPrincipal } from '../tipo';

@Component({
    selector: 'sgt-pessoa-contato-form',
    templateUrl: './pessoa-contato-form.component.html',
    providers: [
        PessoaContatoTipoSortPipe
    ]
})
export class PessoaContatoFormComponent implements OnInit {
    entity: PessoaContato;
    editMode: boolean;

    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;
    @ViewChild('contatoTipoSelect') contatoTipoSelect: ElementRef;
    @ViewChild('contatoNomeInput') contatoNomeInput: ElementRef;

    tipos: PessoaContatoTipo[];
    situacoes = contatoSituacoes;

    constructor(private pessoaContatoTipoSortPipe: PessoaContatoTipoSortPipe,
                private formsUtilsService: FormsUtilsService) { }

    ngOnInit(): void {
        this.tipos = this.pessoaContatoTipoSortPipe.transform(outrosContatosTipos);
    }

    /** Verifica se o tipo do contato é um dos contatos primarios */
    isContatoTipoPrimario() {
        return isContatoTipoPrimario(this.entity.tipo);
    }

    /** Verfica se o tipo de contato é Principal */
    isContatoTipoPrincipal() {
        return isContatoTipoPrincipal(this.entity.tipo);
    }

    insert(tipo: number = null) {
        this.editMode = false;
        this.entity = new PessoaContato(tipo);
        setTimeout(() => this.setFocus(), 0);
    }

    edit(entity: PessoaContato) {
        this.editMode = true;
        this.entity = _.cloneDeep(entity);
        setTimeout(() => this.setFocus(), 0);
    }

    isValid() {
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        return this.form.valid;
    }

    /** Seta o foco no input do nome do contato */
    setFocus() {
        // Se estiver inserindo e não possuir um tipo setado por padrão, seta foco no select do tipo
        if (!this.editMode && !this.entity.tipo) {
            jQuery(this.contatoTipoSelect?.nativeElement).trigger('focus');
            return;
        }

        // Se não, seta o foco no input do nome
        jQuery(this.contatoNomeInput?.nativeElement).trigger('focus');
    }
}
